import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters.js";

const initialState = {
  // Innere ---------|>
  innereTragfaehigkeitsDetails: false,
  angepassteBemessungslast: false,
  knickenCheckbox: false,
  knickenTypeRadio: 1,
  knickenNachOfnerWimmerDetails: false,
  knickenNachDINEN1993Details: false,
  ermuedungCheckbox: false,
  ermuedungDetails: false,

  // Aeussere ---------|>
  // Dgrupe.js
  kompressionspfahlgruppenCheckbox: false,
  kompressionspfahlgruppenDetails: false,

  // Zgrupe.js
  ueberpruefungVonPfahlgruppenCheckbox: false,
  ueberpruefungVonPfahlgruppenDetails: false,

  // Transmission.js
  uebertragungslaengeCheckbox: false,
};

const frontendZustandSlice = createSlice({
  name: "frontendZustand",
  initialState,
  reducers: {
    setFrontendZustandState(state, action) {
      // Does not work:    state = { ...action.payload };
      // const { knickenCheckbox } = action.payload;
      // state = { knickenCheckbox: knickenCheckbox };

      state.innereTragfaehigkeitsDetails = action.payload.innereTragfaehigkeitsDetails;
      state.angepassteBemessungslast = action.payload.angepassteBemessungslast;
      state.knickenCheckbox = action.payload.knickenCheckbox;
      state.knickenTypeRadio = action.payload.knickenTypeRadio;
      state.knickenNachOfnerWimmerDetails = action.payload.knickenNachOfnerWimmerDetails;
      state.knickenNachDINEN1993Details = action.payload.knickenNachDINEN1993Details;
      state.ermuedungCheckbox = action.payload.ermuedungCheckbox;
      state.ermuedungDetails = action.payload.ermuedungDetails;
      state.kompressionspfahlgruppenCheckbox = action.payload.kompressionspfahlgruppenCheckbox;
      state.kompressionspfahlgruppenDetails = action.payload.kompressionspfahlgruppenDetails;
      state.ueberpruefungVonPfahlgruppenCheckbox =
        action.payload.ueberpruefungVonPfahlgruppenCheckbox;
      state.ueberpruefungVonPfahlgruppenDetails =
        action.payload.ueberpruefungVonPfahlgruppenDetails;
      state.uebertragungslaengeCheckbox = action.payload.uebertragungslaengeCheckbox;
    },
    setInnereTragfaehigkeitsDetails(state, action) {
      state.innereTragfaehigkeitsDetails = action.payload;
    },
    setAngepassteBemessungslastCheckbox(state, action) {
      state.angepassteBemessungslast = action.payload;
    },
    setKnickenCheckbox(state, action) {
      state.knickenCheckbox = action.payload;
    },
    setKnickenNachOfnerWimmerDetails(state, action) {
      state.knickenNachOfnerWimmerDetails = action.payload;
    },
    setKnickenTypeRadio(state, action) {
      state.knickenTypeRadio = action.payload;
    },
    setKnickenNachDINEN1993Details(state, action) {
      state.knickenNachDINEN1993Details = action.payload;
    },
    setErmuedungCheckbox(state, action) {
      state.ermuedungCheckbox = action.payload;
    },
    setErmuedungDetails(state, action) {
      state.ermuedungDetails = action.payload;
    },
    setKompressionspfahlgruppeCheckbox(state, action) {
      state.kompressionspfahlgruppenCheckbox = action.payload;
    },
    setKompressionspfahlgruppeDetails(state, action) {
      state.kompressionspfahlgruppenDetails = action.payload;
    },
    setUEbertragungslaengeCheckbox(state, action) {
      state.uebertragungslaengeCheckbox = action.payload;
    },
    setUEberpruefungVonPfahlgruppenCheckbox(state, action) {
      state.ueberpruefungVonPfahlgruppenCheckbox = action.payload;
    },
    setUEberpruefungVonPfahlgruppenDetails(state, action) {
      state.ueberpruefungVonPfahlgruppenDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const {
  setFrontendZustandState,
  setInnereTragfaehigkeitsDetails,
  setAngepassteBemessungslastCheckbox,
  setKnickenCheckbox,
  setKnickenNachOfnerWimmerDetails,
  setKnickenTypeRadio,
  setKnickenNachDINEN1993Details,
  setErmuedungCheckbox,
  setErmuedungDetails,
  setKompressionspfahlgruppeCheckbox,
  setKompressionspfahlgruppeDetails,
  setUEbertragungslaengeCheckbox,
  setUEberpruefungVonPfahlgruppenCheckbox,
  setUEberpruefungVonPfahlgruppenDetails,
} = frontendZustandSlice.actions;

export default frontendZustandSlice.reducer;

export const selectFrontendZustand = (state) => state.frontendZustand;
